<script lang="ts">
  import type { PasswordStrength } from "../../type";

  export let strength: PasswordStrength = "";

  let percentage: string = "0%";

  function updateProgressBarPercentage() {
    if (!strength) {
      percentage = "0%"
    } else if (strength === "weak") {
      percentage = "40%";
    } else if (strength === "medium") {
      percentage = "65%"
    } else {
      percentage = "100%";
    }
  }

  $: strength, updateProgressBarPercentage();
</script>

<div class="bar-container {strength} w-24 h-1 rounded-sm bg-light-100">
  <div class="h-1 rounded-sm" style="width: {percentage};"></div>
</div>

<style lang="postcss">
  .bar-container > div {
    transition: width 0.3s ease-in-out;
  }

  .weak > div {
    @apply bg-tertiary-error;
  }

  .medium > div {
    @apply bg-tertiary-orange;
  }

  .strong > div {
    @apply bg-tertiary-success;
  }
</style>
